import React, { Component } from 'react';
import ResponsiveImage from '../helpers/responsiveImage/ResponsiveImage';

class GalleryComponent extends Component {
    constructor(props) {
        super(props);
    }

    render () {
        const {
            imagesPath,
            imageSizeParams,
            images,
            galleryItemClick,
            imageKey
        } = this.props;

        const get1Block = (images) => (
            <div
                id={`galleryImage${imageKey}_1`}
                key={images[0].file_name}
                className="gallery-block-1">
                <div
                    className="gallery-block-1-img"
                    onClick={(e) => {
                        galleryItemClick(`galleryImage${imageKey}_1`, images[0].file_name, e.target)
                    }}>
                    <ResponsiveImage
                        imagesPath={imagesPath}
                        imageSizeParams={imageSizeParams}
                        filename={images[0].file_name}
                        lazyLoad={true}
                    />
                </div>
            </div>
        );

        const get2Blocks = (images) => {
            const blocks = images.map(img => {
                return (
                    <div
                        key={img.file_name}
                        className="gallery-block-2-img"
                        onClick={(e) => {
                            galleryItemClick(`galleryImage${imageKey}_2`, img.file_name, e.target)
                        }}>
                        <ResponsiveImage
                            imagesPath={imagesPath}
                            imageSizeParams={imageSizeParams}
                            filename={img.file_name}
                            lazyLoad={true}
                        />
                    </div>
                );
            });

            return (
                <div
                    id={`galleryImage${imageKey}_2`}
                    key={images[0].file_name}
                    className="gallery-block-2">
                    {blocks}
                </div>
            );
        }

        const get3Blocks = (images) => {
            return (
                <div
                    id={`galleryImage${imageKey}_3`}
                    key={images[0].file_name}
                    className="gallery-block-3">
                    <div
                        key={images[0].file_name}
                        className="gallery-block-3-img"
                        onClick={(e) => {
                            galleryItemClick(`galleryImage${imageKey}_3`, images[0].file_name, e.target)
                        }}>
                        <ResponsiveImage
                            imagesPath={imagesPath}
                            imageSizeParams={imageSizeParams}
                            filename={images[0].file_name}
                            lazyLoad={true}
                        />
                    </div>
                    <div className="gallery-block-3-row">
                        <div
                            key={images[1].file_name}
                            className="gallery-block-3-img"
                            onClick={(e) => {
                                galleryItemClick(`galleryImage${imageKey}_3`, images[1].file_name, e.target)
                            }}>
                            <ResponsiveImage
                                imagesPath={imagesPath}
                                imageSizeParams={imageSizeParams}
                                filename={images[1].file_name}
                                lazyLoad={true}
                            />
                        </div>
                        <div
                            key={images[2].file_name}
                            className="gallery-block-3-img"
                            onClick={(e) => {
                                galleryItemClick(`galleryImage${imageKey}_3`, images[2].file_name, e.target)
                            }}>
                            <ResponsiveImage
                                imagesPath={imagesPath}
                                imageSizeParams={imageSizeParams}
                                filename={images[2].file_name}
                                lazyLoad={true}
                            />
                        </div>
                    </div>
                </div>
            );
        }

        const galleryBlocks = [];

        switch (images.length) {
            case 5:
                galleryBlocks.push(get3Blocks(images.slice(0, 3)));
                galleryBlocks.push(get2Blocks(images.slice(3, 5)));
                break;
            case 4:
                galleryBlocks.push(get3Blocks(images.slice(0, 3)));
                galleryBlocks.push(get1Block(images.slice(3, 4)));
                break;
            case 3:
                galleryBlocks.push(get3Blocks(images.slice(0, 3)));
                break;
            case 2:
                galleryBlocks.push(get2Blocks(images.slice(0, 2)));
                break;
            case 1:
                galleryBlocks.push(get1Block(images));
                break;
            default:
                break;
        }

        return (
            <div className="gallery-component">
                {galleryBlocks}
            </div>
        )
    }
}

export default GalleryComponent;
